import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ACTIONS from "../../../redux/action.js";
import axios from "../../../shared/axios/axiosProxy.js";
import i18n from "../../../utils/i18n";
import classes from "./kftRegActivityDescription.module.scss";

const KftRegActivityDescription = () => {
  const dispatch = useDispatch();
  const reqMessage = useSelector((state) => state.company_store.reqMessage) || "";
  const searchID = useSelector((state) => state.company_store.searchID);

  const handleChange = useCallback(
    (event) => {
      dispatch(
        ACTIONS.addCompanyInfo({
          id: "reqMessage",
          data: event.target.value,
          stateObject: "company_store",
        }),
      );
    },
    [dispatch],
  );

  const handleBlur = useCallback(() => {
    if (!searchID || searchID === "undefined" || searchID === "null") {
      return;
    }

    axios
      .patch(
        `/api/search/${searchID}`,
        { reqMessage },
        { headers: { "Content-Type": "application/json" } },
      )
      .catch((error) => {
        console.error(
          "Error saving reqMessage to search:",
          error.response?.data || error.message,
        );
      });
  }, [reqMessage, searchID]);

  return (
    <div className={classes.root}>
      <div className={classes.scrollArea}>
        <div className={classes.content}>
          <div className={classes.mainColumn}>
            <header className={classes.header}>
              <h1 className={classes.title}>
                {i18n.t("searchflow.activitydescriptiontitle")}
              </h1>
              <p className={classes.subtitle}>
                {i18n.t("searchflow.activitydescriptionsubtitle")}
              </p>
            </header>

            <div className={classes.rightColumn}>
              <div className={classes.messageField}>
                <label
                  className={classes.messageLabel}
                  htmlFor="kftreg-activity-description-message"
                >
                  {i18n.t("searchflow.vafmessagelabel")} -{" "}
                  {i18n.t("general.obligartory")}
                </label>
                <textarea
                  id="kftreg-activity-description-message"
                  className={classes.messageTextarea}
                  value={reqMessage}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={i18n.t("searchflow.regindustryreqmessageph")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KftRegActivityDescription;
